import { inject, InjectionToken } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { getPreferredFromRecord } from '@suvo/shared/hashmaps';

/** Unwraps an i18n mapped value using {@link TranslateService} configuration. */
export const unwrapI18n = new InjectionToken('unwrapI18n', {
  factory: () => {
    const translateService = inject(TranslateService);
    return <T>(i18nRecord: Record<string, T>, fallbackLangs = ['en']) =>
      getPreferredFromRecord(
        i18nRecord,
        translateService.currentLang,
        translateService.defaultLang,
        ...fallbackLangs,
      );
  },
});
